import React from 'react';
import {useracc, postApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';


import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default class Login extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {};
  };

  
  
  async componentDidMount() {
		document.title = "Mix365 Radio - Thank you for visiting mix365 and see you soon";

		var params = new URLSearchParams();
		await postApi('/api/v1/logout', params);

		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );

		EventEmitter.emit('/socket/reconnect', {data: 'no value'});

	}

	componentWillUnmount() {
	}


	

	render() {
		
		return (
			<>
				<div className="website-background"></div>
				<Container>
					<Row>
						<Col>Thank you for visiting mix365 </Col>
					</Row>
					<Row>
						<Col>See you soon</Col>
					</Row>
				</Container>
			</>
		);
	}
}
